// extracted by mini-css-extract-plugin
export default {"container":"CheckoutSuccess_container__OAKsv","btn":"CheckoutSuccess_btn__feYlK"};